<mat-paginator #paginator [length]="totalItems" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent($event)"
  [showFirstLastButtons]="true">
</mat-paginator>
